<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br><br>
                    <div>
                        <p class="texto1">Cotización en pausa<br></p>
                        <p class="texto2">No pudimos validar tu identidad.</p>
                        <p class="texto2"><span class="texto3">¡No te preocupes!</span> ya tenemos tus datos y nos<br>
                            pondremos en contacto contigo para continuar con el <br>proceso :)
                        </p>
                    </div>

                    <img src="./assets/img/Candado.png" />
                </div>
                <div class="textoAbajo">
                    <img src="./assets/img/Candado.png" />

                    <div>
                        <p class="texto1">Cotización en pausa<br></p>
                        <p class="texto2">No pudimos validar tu identidad.</p>
                        <p class="texto2">
                            <span class="texto3">¡No te preocupes!</span> ya tenemos tus datos y <br>
                            nos pondremos en
                            contacto contigo para continuar con el <br>proceso :)
                        </p>
                    </div>
                </div>
                <br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="volverInicio()">
                        Volver al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>